import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as actions from './redux/actions';
import { HEAD_DEFAULT, MyIcon } from '../../common/baseConfig';
import { Carousel, Button } from 'antd';
export class BannerBody extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchBannerList();
    this.props.actions.fetchStudentPublicList();
  }
  gotoRegister() {
    this.props.history.push('/register');
  }
  gotoLogin() {
    this.props.history.push('/login');
  }
  gotoCenter() {
    this.props.history.push('/center');
  }
  jumpToMsg(item) {
    this.props.history.push(`/center/message/0?MessageID=${item.MessageId}`);
  }
  renderMenuList(disciplineList) {
    let { isShowAdImage } = this.props.home;
    return (
      <div className={isShowAdImage ? 'discipline_detail_1' : 'discipline_detail'}>
        {disciplineList.map((item, key) => (
          <div className="discipline_detail_item" key={key}>
            <p>
              {item.ReType === 1 ? (
                <Link to={`/courseList/${item.Discipline_ID}-0-0`} className="link">
                  {item.Img && <img src={item.Img} alt="" />}
                  {item.Name}
                </Link>
              ) : (
                <a
                  href={item.Url ? item.Url : ''}
                  target={item.OpenType === 0 ? '_self' : '_blank'}
                  className="link"
                >
                  {item.Img && <img src={item.Img} alt="" />}
                  {item.Name}
                </a>
              )}
            </p>
            <ul>
              {item.ChildNodeList &&
                item.ChildNodeList.map((it, i) => {
                  return (
                    <li key={i}>
                      {it.ReType === 1 ? (
                        <Link
                          to={`/courseList/${it.Discipline_CID}-${it.Discipline_ID}-0`}
                          className="link"
                        >
                          {it.Name}
                        </Link>
                      ) : (
                        <a
                          href={it.Url ? it.Url : ''}
                          target={item.OpenType === 0 ? '_self' : '_blank'}
                          className={it.Ishot === 1 ? 'link_hot' : 'link'}
                        >
                          {it.Name}
                        </a>
                      )}
                    </li>
                  );
                })}
            </ul>
            <div className="ani_underline"></div>
          </div>
        ))}
      </div>
    );
  }
  render() {
    const { bannerList = [], disciplineList = [], messageData = [] } = this.props;
    const { fetchGetConfigurationSuccess, studentBasics } = this.props.common;
    const {
      isShowAdImage,
      adImageData,
      recommendData,
      isShowRecommend,
      isShowVip,
      vipData,
    } = this.props.home;

    const studentBasicsKeyList = Object.keys(studentBasics);
    const { HeadImg = null, Name = '' } = studentBasics;
    const isLogin = studentBasicsKeyList.length > 0 ? true : false;
    const messageDataMin = messageData && [...messageData];
    const lessonRecord = this.props.courseLookInfo;

    const ImgType = 1;
    return (
      <div className="home-banner-body">
        <div className="banner_body_container">
          <div className="banner_body_container_wrap">
            <div className="carousel_wrap">
              {bannerList.length > 0 && (
                <Carousel autoplay dotPosition={'bottom'} effect={'fade'}>
                  {bannerList.map((item, key) => (
                    <div key={key} className="carousel_item">
                      <div
                        className="carousel_item_content"
                        style={{ background: item.BgColor || '#F0F2F5' }}
                      >
                        <a href={item.Url} target="_blank">
                          <img
                            className="banner_img"
                            src={item.PicUrl + '?x-oss-process=image/resize,m_fixed,h_460,w_700'}
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </Carousel>
              )}
            </div>
            <div className="cover_wrap">
              <div className="cover_wrap_inner">
                <div className="banner_body_discipline">
                  <div
                    className="banner_body_discipline_header"
                    onClick={() => this.props.history.push('/center')}
                  >
                    进入我的网校
                  </div>
                  {this.renderMenuList(disciplineList)}
                </div>
                <div className="banner_body_login">
                  <div className="login_head">
                    <h1>
                      <img
                        className="headPic"
                        src={isLogin && HeadImg ? HeadImg : HEAD_DEFAULT}
                        alt=""
                      />
                      <div className="content">
                        <p className="p1">
                          <span className="sp1">{isLogin ? Name : 'Hello，'}</span>
                          <span className="sp2">{isLogin ? ' 学员' : '欢迎来到网校'}</span>
                        </p>
                        <p className="p2">{isLogin ? '祝君学习愉快' : '开始你的学习之旅'}</p>
                      </div>
                    </h1>
                    {isLogin ? (
                      <h2>
                        <Button
                          className="go_center_btn"
                          type="theme"
                          onClick={() => this.gotoCenter()}
                        >
                          进入学习中心
                        </Button>
                      </h2>
                    ) : (
                      <h2>
                        <Button className="login_btn" type="theme" onClick={() => this.gotoLogin()}>
                          登录
                        </Button>
                        {fetchGetConfigurationSuccess &&
                          fetchGetConfigurationSuccess.RegisterValid === 1 && (
                            <Button
                              className="register_btn"
                              type="theme2"
                              onClick={() => this.gotoRegister()}
                            >
                              注册
                            </Button>
                          )}
                      </h2>
                    )}
                  </div>
                  {isLogin ? (
                    <div className="login_menus">
                      <h1>
                        <div
                          className="login_menu"
                          onClick={() => this.props.history.push('/center/myOrder/0')}
                        >
                          <MyIcon className="menu_icon" type="icondingdan" />
                          <p>订单</p>
                        </div>
                        <div
                          className="login_menu"
                          onClick={() => this.props.history.push('/courseList')}
                        >
                          <MyIcon className="menu_icon" type="iconkecheng" />
                          <p>课程</p>
                        </div>
                        <div
                          className="login_menu"
                          onClick={() => this.props.history.push('/center/startExer/0')}
                        >
                          <MyIcon className="menu_icon" type="icontiku" />
                          <p>题库</p>
                        </div>
                      </h1>
                    </div>
                  ) : isShowRecommend ? (
                    <div className="login_menus">
                      <h1>
                        {recommendData &&
                          recommendData.map(item => (
                            <div
                              className="login_menu"
                              key={item.ID}
                              onClick={() => (item.Url ? window.open(item.Url || '') : '')}
                            >
                              <img
                                src={item.IconUrl}
                                style={{ width: '28px', height: '28px' }}
                                alt=""
                              />
                              <p>{item.VIPDescription}</p>
                            </div>
                          ))}
                      </h1>
                    </div>
                  ) : (
                    ''
                  )}
                  {isLogin && (
                    <div className="login_learning_record">
                      {lessonRecord && lessonRecord.length > 0 ? (
                        <div>
                          <h1>
                            <MyIcon type="iconxuexijilu1" className="record_icon" />
                            <span>学习记录</span>
                          </h1>
                          <h2>{lessonRecord[0][0].Name}</h2>
                          <h3>
                            <span>
                              已学{' '}
                              {lessonRecord[0][0].LookHours >= lessonRecord[0][0].SumHours
                                ? '100'
                                : (
                                    (lessonRecord[0][0].LookHours / lessonRecord[0][0].SumHours) *
                                    100
                                  ).toFixed(0)}
                              %
                            </span>
                            <span>学习至{lessonRecord[0][0].ChapterName}</span>
                          </h3>
                          <h4
                            onClick={() => {
                              this.props.history.push(
                                `/course/video/${lessonRecord[0][0].ID}-${lessonRecord[0][0].CourseChapters_ID}-${lessonRecord[0][0].WareId}`,
                              );
                            }}
                          >
                            继续学习 >>
                          </h4>
                        </div>
                      ) : (
                        <div>
                          <h1>
                            <MyIcon type="iconxuexijilu1" className="record_icon" />
                            <span>学习记录</span>
                          </h1>
                          <Link className="my-course-link" to="/center/courseManage/0">
                            您还没有观看任何课程哦，快去观看学习吧 >>
                          </Link>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="login_messages">
                    {messageDataMin && messageDataMin.length > 0 ? (
                      <p
                        onClick={() => {
                          this.jumpToMsg(messageDataMin[0]);
                        }}
                      >
                        <MyIcon className="message_icon" type="iconxitongxiaoxi" />
                        <span>{messageDataMin[0].Title}</span>
                      </p>
                    ) : (
                      <p>
                        <MyIcon className="message_icon" type="iconxitongxiaoxi" />
                        <span>暂无消息</span>
                      </p>
                    )}
                  </div>
                  {!isLogin && isShowVip && (
                    <div className="login_students_enjoy_on">
                      <h1>
                        <MyIcon className="enjoy_on_icon" type="iconxueyuanzhuanxiang" />
                        <span>学员专享</span>
                      </h1>
                      <h2>
                        {vipData.map(
                          (item, index) =>
                            item.VIPDescription && (
                              <p key={item.ID}>
                                {index + 1}. {item.VIPDescription}
                              </p>
                            ),
                        )}
                      </h2>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {isShowAdImage && (
            <div className="banner_ad_content">
              <div className="ad_content_box">
                {adImageData &&
                  adImageData.map(
                    item =>
                      item.IconUrl &&
                      (item.Url ? (
                        <a
                          href={item.Url}
                          target="_blank"
                          className={
                            item.ImgType === ImgType
                              ? 'ad_content_item first_item'
                              : 'ad_content_item second_item'
                          }
                          key={item.ID}
                        >
                          <img
                            style={{ width: '100%', height: '100%' }}
                            src={item.IconUrl}
                            alt=""
                          />
                        </a>
                      ) : (
                        <a
                          className={
                            item.ImgType === ImgType
                              ? 'ad_content_item first_item'
                              : 'ad_content_item second_item'
                          }
                          key={item.ID}
                        >
                          <img
                            style={{ width: '100%', height: '100%' }}
                            src={item.IconUrl}
                            alt=""
                          />
                        </a>
                      )),
                  )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    bannerList: state.home.bannerList,
    common: state.common,
    home: state.home,
    messageData: state.home.messageData,
    courseLookInfo: state.center.fetchGetLookInfoSuccess,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BannerBody));



// WEBPACK FOOTER //
// ./src/features/home/BannerBody.js